<div class="header">
  <div class="title">Add Address</div>
  <button class="close-button" mat-icon-button (click)="discard()" [tabIndex]="-1">
    <mat-icon [svgIcon]="'close'"></mat-icon>
  </button>
</div>

<form [formGroup]="addPropertyForm">
  <mat-form-field class="flex-auto gt-xs:pr-3">
    <mat-label>Name</mat-label>
    <input matInput placeholder="Name" formControlName="name" autocomplete="none" (blur)="nameBlur()" />
  </mat-form-field>
  <mat-hint *ngIf="propertiesFoundByName?.length && !propertyAlreadyChild" class="mb-3">
    <p>One or more properties with the same name exists:</p>
    <ul class="existing-properties-name">
      <li
        class="flex items-center justify-between mt-3 existing-projects__list"
        *ngFor="let property of propertiesFoundByName; let i = index"
      >
        <a class="link" (click)="goToProperty(property)"
          >{{ property.name }} <span *ngIf="property.address_string">[{{ property.address_string }}]</span></a
        >
        <button
          class="ml-4 send-button"
          id="add-existing-deal-form-button"
          (click)="addPropertyToProject(property, i)"
          mat-flat-button
          [color]="'primary'"
        >
          <span *ngIf="i !== activeButtonIndex">Add to Deal</span>
          <mat-progress-spinner *ngIf="i === activeButtonIndex" [diameter]="24" [mode]="'indeterminate'">
          </mat-progress-spinner>
        </button>
      </li>
    </ul>
  </mat-hint>
  <!-- Subject -->
  <mat-form-field class="flex-auto gt-xs:pr-3">
    <mat-label>Property Type</mat-label>
    <mat-select [formControlName]="'property_type_id'">
      <mat-option *ngFor="let propertyType of propertyTypes" [value]="propertyType.id">
        {{ propertyType.name }}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <fieldset [formGroupName]="'address'">
    <div class="flex flex-col gt-xs:flex-col">
      <mat-form-field class="flex-auto gt-xs:pr-3">
        <mat-label>Address</mat-label>
        <input
          matInput
          google-place
          placeholder="Address"
          [formControlName]="'street'"
          (onSelectParts)="setAddressParts($event)"
          autocomplete="none"
          (blur)="addressBlur()"
        />
      </mat-form-field>
      <mat-hint
        *ngIf="duplicateAddressProperties && duplicateAddressProperties.length > 0 && !propertyAlreadyChild"
        class="mb-3"
      >
        <p>One or more properties with the same address already exists:</p>
        <ul class="existing-properties">
          <li
            class="flex items-center justify-between mt-3 existing-projects__list"
            *ngFor="let property of duplicateAddressProperties; let i = index"
          >
            <a class="link" (click)="goToProperty(property)">{{ property.address_string }}</a>
            <button
              class="send-button"
              id="add-existing-deal-form-button"
              (click)="addPropertyToProject(property, i)"
              mat-flat-button
              [color]="'primary'"
              [disabled]="addPropertyForm.pristine || addPropertyForm.invalid"
            >
              <span *ngIf="i !== activeButtonIndex">Add to Deal</span>
              <mat-progress-spinner *ngIf="i === activeButtonIndex" [diameter]="24" [mode]="'indeterminate'">
              </mat-progress-spinner>
            </button>
          </li>
        </ul>
      </mat-hint>
      <mat-hint
        *ngIf="duplicateAddressProperties && duplicateAddressProperties.length > 0 && propertyAlreadyChild"
        class="mb-3"
      >
        <p>This property already exists in this deal.</p>
      </mat-hint>
    </div>
    <div class="flex flex-col gt-xs:flex-row">
      <mat-form-field class="flex-auto gt-xs:pr-3">
        <mat-label>City</mat-label>
        <input matInput [formControlName]="'city'" (blur)="addressBlur()" />
      </mat-form-field>
      <mat-form-field class="flex-auto gt-xs:pr-3">
        <mat-label>State</mat-label>
        <input matInput [formControlName]="'state'" (blur)="addressBlur()" />
      </mat-form-field>
      <mat-form-field class="flex-auto gt-xs:pr-3">
        <mat-label>Zip</mat-label>
        <input matInput [formControlName]="'postal_code'" (blur)="addressBlur()" />
      </mat-form-field>
    </div>
  </fieldset>

  <!-- Body -->

  <div class="actions justify-end">
    <div class="buttons">
      <!-- Discard -->
      <button class="discard-button" mat-button type="button" (click)="discard()">
        <span>Cancel</span>
      </button>

      <!-- Send -->
      <button
        class="send-button"
        mat-flat-button
        [color]="'primary'"
        type="submit"
        [disabled]="addPropertyForm.pristine || addPropertyForm.invalid"
        (click)="save()"
      >
        <span *ngIf="!addPropertyForm.disabled">Save</span>
        <mat-progress-spinner
          *ngIf="addPropertyForm.disabled"
          [diameter]="24"
          [mode]="'indeterminate'"
        ></mat-progress-spinner>
      </button>
    </div>
  </div>
</form>
